import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import authApi from '../../../service/IdApi'; // Ensure this import is correct
import { useAppContext } from '../../../context/appContext'; // Ensure this import is correct

const AddCreditsDialog = ({ visible, onHide, providerId, refetch }) => {
    const { displayAlert } = useAppContext();
    const [creditAmount, setCreditAmount] = useState('');
    const [creditDescription, setCreditDescription] = useState('');

    const handleCreditAmountChange = (e) => {
        setCreditAmount(e.value || 0);
    };

    const submitCredits = async () => {
        const body = {
            providerId, // Use the providerId passed as a prop
            amount: parseFloat(creditAmount),
            description: creditDescription
        };
        try {
            await authApi.post("admin/provider/credits", body);
            onHide();
            refetch(); // Call refetch to update the data
        } catch (error) {
            console.error("Error adding credits:", error);
            displayAlert("error", "Unexpected Error", "Please try again later");
        }
    };

    return (
        <Dialog
            visible={visible}
            style={{ width: '30vw' }}
            header="Add Credits"
            modal
            onHide={onHide}
            className="p-fluid"
        >
            <div className="field">
                <label htmlFor="amount">Amount</label>
                <InputNumber
                    id="amount"
                    name="amount"
                    value={creditAmount}
                    onChange={handleCreditAmountChange}
                    mode="currency"
                    currency="USD"
                    locale="en-US"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                />
            </div>
            <div className="field">
                <label htmlFor="description">Description</label>
                <input
                    id="description"
                    type="text"
                    value={creditDescription}
                    onChange={(e) => setCreditDescription(e.target.value)}
                    className="p-inputtext p-component"
                />
            </div>
            <div className="flex justify-content-end">
                <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
                <Button label="Submit" icon="pi pi-check" onClick={submitCredits} autoFocus />
            </div>
        </Dialog>
    );
};

export default AddCreditsDialog;